<template>
  <v-app style="background:black">
    <v-main class="text-center mt-15">
      <div>
        <h1 style="font-size:24px" class="white--text font-weight-bold">Signup 🎉</h1>
        <p style="font-size:13px" class="white--text">Create an account in less than a minute!</p>
      </div>
      <div class="animate__animated animate__fadeInUp animate__fast mb-3">
        <v-btn
          @click="googleSignup()"
          large
          width="300px"
          height="50px"
          color="#e50914"
          class="white--text"
          style="border-radius:12px"
          ><v-icon class="mr-2">mdi-google</v-icon> Continue with Google</v-btn
        >
      </div>
      <div class="animate__animated animate__fadeInUp">
        <v-btn
          @click="facebookSignup()"
          large
          width="300px"
          height="50px"
          color="#e50914"
          class="white--text"
          style="border-radius:12px"
          ><v-icon class="mr-2">mdi-facebook</v-icon> Continue with
          Facebook</v-btn
        >
      </div>
      <div class="or">
                <h2 class="orText">OR</h2>
                <div class="line"></div>
              </div>
      <div style="width:100%;margin:auto">
       <v-form @submit.prevent="pressed()">
        <v-text-field
          v-model="email"
          color="black"
          label="Email Address"
          style="border-radius:0px;width:300px;margin:auto;height:56px;background:white;border-color:black"
          filled
          class="black--text mb-3"
        />
        </v-form>
        <v-form @submit.prevent="pressed()">
        <v-text-field
          color="black"
          style="color:black;border-radius:0px;width:300px;margin:auto;height:56px;background:white;border-color:black"
          filled
          label="Password"
          v-model="password"
          class="black--text mb-4"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          @click:append="show = !show"
        />
        </v-form>
      </div>

      <v-btn
        x-large
        width="300px"
        height="60px"
        class="white--text"
        color="#e50914"
        style="border-radius:12px"
        @click="pressed()"
        :loading="loading"
        >Signup</v-btn
      >
      <p
        class="animate__animated animate__fadeInUp animate__delay-1s"
        style="color:white;padding-top:15px"
      >
        Already have an account?
        <router-link style="color:#e50914" to="/login">Login</router-link>
      </p>
    </v-main>
  </v-app>
</template>

<script>
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  onAuthStateChanged,
  signInWithRedirect,
  createUserWithEmailAndPassword
} from "firebase/auth";
import { mapGetters } from "vuex";

export default {
  name: "Signup",
  data() {
    return {
      show: false,
      email:"",
      password:"",
      loading:false
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  metaInfo: {
    title: "Signup",
    titleTemplate: "%s | Tippings ",
    meta: [
      {
        name: "description",
        content: "Seamlessly get rewarded for your creativity on Tippings",
      },
      {
        property: "og:title",
        content: " Signup | Tippings",
      },
      { property: "og:site_name", content: "Tippings" },
      {
        property: "og:description",
        content: "Seamlessly get rewarded for your creativity on Tippings",
      },
      { property: "og:type", content: "profile" },
      {
        property: "og:url",
        content: "https://tippings.me/",
      },
      { property: "og:image", content: "" },
    ],
  },

  created() {
    this.$vuetify.theme.dark = false
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.$router.push("/setup-account");
      }
    });
  },


  methods: {
    pressed(){
      this.loading = true
      if(this.email ==""){
      this.$swal({
          title: "Enter your email!",
          text: "You need to enter your email address",
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false
      } else if(this.password == ""){
         this.$swal({
          title: "Enter your Password",
          text: "You need to enter your password",
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false
      } else{
        const auth = getAuth();
        createUserWithEmailAndPassword(auth,this.email,this.password)
        .then((response) =>{
         console.log(response)
         this.$router.push('/setup-account')
         this.loading = false
        }).catch((error) =>{
          console.log(error)
           this.$swal({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false
        })
      } 
    },
    googleSignup() {
      const auth = getAuth();
      const user = auth.currentUser;
      console.log(user);
      const provider = new GoogleAuthProvider();
      signInWithRedirect(auth, provider)
        .then((result) => {
          const token = credential.accessToken;
          console.log(token);
          const credential = GoogleAuthProvider.credentialFromResult(result);
          result.user;
          this.$router.push("/setup-account");
        })
        .catch((error) => {
          const errorCode = error.code;
          console.log(errorCode);
          const errorMessage = error.message;
          console.log(errorMessage);
          const email = error.email;
          console.log(email);
          const credential = GoogleAuthProvider.credentialFromError(error);
          console.log(credential);
        });
    },

    facebookSignup() {
      const auth = getAuth();
      const provider = new FacebookAuthProvider();

      signInWithPopup(auth, provider)
        .then((result) => {
          // The signed-in user info.
          const user = result.user;
          console.log(user.uid);
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const credential = FacebookAuthProvider.credentialFromResult(result);
          const accessToken = credential.accessToken;
          console.log(accessToken);
          this.$router.push("/setup-account");
          // ...
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.or {
  text-align: center;
  width:300px;
  margin:auto auto 20px auto
}

.line {
  height: 1px;
  background:white;
}

.orText {
  position: relative;
  top: 10px;
  color: white;
  font-size: 13px;
  background: black;
  display: inline-block;
  padding: 0 20px;
  border-radius: 30px;
}

.socialLoginposition {
  margin: 10px auto auto auto;
}

.headerPosition {
  text-align: center;
}

@media only screen and (max-width: 1200px) {
  .socialLoginposition {
    margin: auto auto auto auto;
  }
  .headerPosition {
    text-align: center;
  }
}
@media only screen and (max-width: 600px) {
  .socialLoginposition {
    margin: auto auto auto auto;
  }
  .headerPosition {
    text-align: left;
  }
}
@media only screen and (max-width: 425px) {
  .socialLoginposition {
    margin: auto auto auto auto;
  }
  .headerPosition {
    text-align: left;
  }
}
</style>
